module.exports = angular.module('cartographer.common.boolean', [])

module.exports.filter 'yesno', $DI ->
  (value) ->
    if value then 'yes' else 'no'

module.exports.filter 'yesnounknown', $DI ->
  (value) ->
    if value? then (if value then 'yes' else 'no') else 'unknown'
